// extracted by mini-css-extract-plugin
export default {"progressBar":"profile_completion_bar-module___progressBar___c8112fbc"};